<div class="card filter-panel">
  <div class="card-body">
    <div class="title">{{title}}</div>
    <div class="mt-1"></div>
    <button class="text-link" (click)="onSelectAllClick()">
      {{ isLongList ? 'Select Shown' : 'Select All' }}
    </button>
    <span class="mx-1"></span>
    <button class="text-link" (click)="onClearAllClick()">Clear All</button>

    @if (isLongList) {
      <div class="mt-2">
        <input
          type="text"
          placeholder="Search..."
          class="form-control form-control-sm search-input"
          [(ngModel)]="searchTerm"
        />
        <cdk-virtual-scroll-viewport itemSize="22" class="virtual-scroll-container mt-2">
          @for (item of displayedItems; track item.id) {
            <div class="virtual-scroll-item">
              <input
                type="checkbox"
                [checked]="item.selected"
                [value]="item.id"
                (change)="onSelectionChange(item)"
              />
              <label class="mx-1">{{item.label}}</label>
            </div>
          }
        </cdk-virtual-scroll-viewport>
      </div>
    } @else {
      <div class="mt-2">
        @for (item of displayedItems; track item.id) {
          <div>
            <input
              type="checkbox"
              [checked]="item.selected"
              [value]="item.id"
              (change)="onSelectionChange(item)"
            />
            <label class="mx-1">{{item.label}}</label>
          </div>
        }
      </div>

      @if (items.length > INITIAL_DISPLAY_COUNT) {
        <a class="text-link mt-2" (click)="toggleView()">
          {{ isExpanded ? 'See less...' : 'See more...' }}
        </a>
      } }
  </div>
</div>
